import { Loading } from 'ui'
import { useCart } from 'hooks/graphql/legacy-api'
import { useCartContext } from '@/context/CartContext'
import dynamic from 'next/dynamic'

const CartItemSummary = dynamic(() => import('./CartItemSummary'), {
	loading: () => <Loading />
})

export default function CartReviewPanel() {
	const { cart, loading } = useCart()
	const { newCartItemInfo } = useCartContext()

	if (loading || !cart) {
		return <Loading />
	}

	return (
		<div className="flex flex-col space-y-4">
			{newCartItemInfo?.map((cartItem) => (
				<CartItemSummary key={cartItem.token} cart={cart} item={cartItem} />
			))}
		</div>
	)
}
